import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DashBoardComponent } from './components/dashboard/dashboard.component';
import { LoginComponent } from './components/login/login.component';

import { FormWorkFlowComponent } from './components/workflow/form-workflow/form-workflow.component'

import { ListWorkFlowReportComponent } from './components/workflowreport/list.workflowreport.component';
import { CreatorGuardService } from './services/auth-guard-creator.service';
import { ReviewerGuardService } from './services/auth-guard-reviewer.service';
import { GroupsComponent } from './components/groups/groups.component';
import { ReportHTMLComponent } from './components/workflowreport/report-html/report-html.component';
import { ManagerCreatorGuardService } from './services/auth-guard-manager-creator.service';
import { ManagerGuardService } from './services/auth-guard-manager.service';
import { TwofactorComponent } from './components/twofactor/twofactor.component';


const routes: Routes = [
  { path: '', component: LoginComponent },
  { path: 'workflowreport', component: ListWorkFlowReportComponent, canActivate: [ReviewerGuardService], data: { title: 'menu_reports', showHeader: true } },
  { path: 'workflowreport/report/:id', component: ReportHTMLComponent, canActivate: [ReviewerGuardService], data: { title: 'menu_reports' } },
  { path: 'dashboard', component: DashBoardComponent, canActivate: [ManagerCreatorGuardService], data: { title: 'menu_workflows', showHeader: true } },
  { path: 'dashboard/workflow', component: FormWorkFlowComponent, canActivate: [CreatorGuardService], data: { title: 'menu_workflows', showHeader: true } },
  { path: 'dashboard/workflow/:id', component: FormWorkFlowComponent, canActivate: [CreatorGuardService], data: { title: 'menu_workflows', showHeader: true } },
  { path: 'groups', component: GroupsComponent, canActivate: [ManagerGuardService], data: { title: 'menu_groups', showHeader: true } },
  { path: 'twofactor', component: TwofactorComponent, data: { title: 'two_factor_title' } },
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  // , { relativeLinkResolution: 'corrected' }
  exports: [RouterModule],
  providers: []
})
export class AppRoutingModule {

  constructor() {

  }

}
